import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { MDCMenuSurface, Corner } from '@material/menu-surface';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

import 'next/stylesheets/components/resource/header-menu';

function createElementFromHTML(htmlString) {
  const element = document.createElement('div');
  element.innerHTML = htmlString.trim();
  return element.firstChild;
}

Component('tr-resource-header-menu', {
  mixins: [eventListenerMixin],

  properties: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    [this.anchor, this.menuSurface] = this.children;
    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurface);
    this.mdcMenuSurface.setAnchorCorner(Corner.BOTTOM_LEFT);

    this.listenTo(this.anchor, 'click', () => {
      this.mdcMenuSurface.open = !this.mdcMenuSurface.open;
    });

    this.listenTo(this.menuSurface, 'click', this.handleMenuSurfaceClick.bind(this));

    this.listenTo(this.mdcMenuSurface, 'MDCMenuSurface:closed', () => {
      this.hideAllForms();
    });

    $(this).on('ajax:success', 'form', () => {
      this.mdcMenuSurface.open = false;
    });
  },

  handleMenuSurfaceClick(event) {
    const item = closest(event.target, '.mdc-list-item');
    if (item && item.dataset.action) {
      this.getActionForm(item.dataset);
      return;
    }

    const cancelButton = closest(event.target, '.button-cancel');
    if (cancelButton) this.mdcMenuSurface.open = false;
  },

  getActionForm({ action, url }) {
    this.hideAllForms();
    const form = this.querySelector(`[data-form-action="${action}"]`);
    if (form) {
      form.classList.add('active');
    } else {
      this.loading = true;
      $.ajax({
        url,
        method: 'GET',
        dataType: 'script',
      });
    }
  },

  showActionForm({ action, template }) {
    this.hideAllForms();
    const form = createElementFromHTML(template);
    form.setAttribute('data-form-action', action);
    this.menuSurface.insertBefore(form, this.menuSurface.firstChild);
    this.querySelector(`[data-form-action="${action}"]`).classList.add('active');
    this.loading = false;
  },

  hideAllForms() {
    [...this.querySelectorAll('.active[data-form-action]')].forEach((form) => {
      form.classList.remove('active');
    });
  },

  disconnected() {
    this.stopListening();
    $(this).off();
    if (this.mdcMenuSurface) this.mdcMenuSurface.destroy();
  },
});
